<template>
    <div class="col-12">
        <div class="form__item">
            <div class="form__item__label form__item__label--required">{{label}}</div>
            <div class="form__item__input-wrapper form__item__input-wrapper--checkbox">
                <input v-model="valEdit" type="radio" value="Oui"/> Oui
                <input v-model="valEdit" type="radio" value="Non"/> Non
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CustomRadioInput',
        data() {
            return {
                valEdit: this.val,
            }
        },
        props: {
            val: {
                required: true,
            },
            label: {
                type: String,
            },
        },
        watch: {
          valEdit: function(newVal, oldVal) {
            this.$emit('update:val', newVal);
          },
          val() {
            this.valEdit = this.val;
          }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Garantie/DealerInsuranceCampingCar/CustomRadioInput.vue